import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Helmet } from 'react-helmet-async';
import { Routes } from 'react-router-dom';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import { withCookies } from 'react-cookie';
import routes from '@client/pages/routes';
import { routeWithSubRoutes, withRouter } from '@client/shared/utils/routerUtils/routerUtils';
import MainFooter from '@client/containers/appFrame/mainFooter/MainFooter';
import { selectCommonDataTranslations } from '@client/redux/commonData/commonDataReducer';
import NotificationProvider from '@client/components/notificationProvider/NotificationProvider';
import { trackCustomEvent } from '@client/tracking/GTM';
import { EVENT_ROUTE_CHANGE } from '@client/definitions/tracking';
import { Navigation } from '@client/components/navigation/Navigation';
import { TopNavigation } from '@client/components/navigation/TopNavigation';
import ErrorBoundary from './errorBoundary/ErrorBoundary';
import styles from './appFrame.scss';

const MainRouteSwitch = () => {
  function getMainClassName() {
    return classNames({
      [styles.main]: true,
    });
  }

  return (
    <main className={getMainClassName()}>
      <Routes>
        {routes.map((route, index) => routeWithSubRoutes(route, index))}
      </Routes>
    </main>
  );
};

class AppFrame extends PureComponent {
  componentDidUpdate(prevProps) {
    const { location } = this.props;
    if (location.pathname !== prevProps.location.pathname) {
      trackCustomEvent(EVENT_ROUTE_CHANGE);
      window.scrollTo(0, 0);
    }
  }

  render() {
    const { translations } = this.props;

    return (
      <ErrorBoundary>
        <div className={styles.appFrame} id="app-container">
          <Helmet title="Hjärt-Lungfonden" />
          <TopNavigation />
          <Navigation />
          <NotificationProvider>
            <div
              className={styles.mainContentBelowHeader}
              id="content-below-header"
            >
              <MainRouteSwitch />
            </div>
          </NotificationProvider>
          <MainFooter texts={translations} />
        </div>
      </ErrorBoundary>
    );
  }
}

AppFrame.propTypes = {
  location: PropTypes.object,
  history: PropTypes.object,
  cookies: PropTypes.object,
  isAuth0Authenticated: PropTypes.bool,
  translations: ImmutablePropTypes.map,
};

function mapStateToProps(state) {
  return {
    translations: selectCommonDataTranslations(state),
  };
}

export default withRouter(withCookies(connect(mapStateToProps)(AppFrame)));
